import React, { useState, useEffect, useRef, useCallback } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    Popconfirm,
    Card as AntCard,
    ProTableOt,
    Form,
    Input,
    useProTableOt,
    setParamsFilter,
    Alert
} from "../../ui/ot";
// import { useQuestionAndAnswer } from "../controller/question_and_answer_controller";
import GeneralBibliographicEditModeForm from "./general_bibliographic_edit_mode_form";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { t } from "i18next";
import dayjs from 'dayjs';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "../../ui/card";
import styled from "styled-components";

/* ── Bootstrap Icons (inline SVG) ── */
const IconBook = ({ size = 16, ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="currentColor" viewBox="0 0 16 16" {...props}>
        <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783"/>
    </svg>
);
const IconJournalText = ({ size = 16, ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="currentColor" viewBox="0 0 16 16" {...props}>
        <path d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"/>
        <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2"/>
        <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"/>
    </svg>
);
const IconFloppy = ({ size = 16, ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="currentColor" viewBox="0 0 16 16" {...props}>
        <path d="M11 2H9v3h2z"/>
        <path d="M1.5 0h11.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.5 0M1 1.5v13a.5.5 0 0 0 .5.5H2v-4.5A1.5 1.5 0 0 1 3.5 9h9a1.5 1.5 0 0 1 1.5 1.5V15h.5a.5.5 0 0 0 .5-.5V2.914a.5.5 0 0 0-.146-.353l-1.415-1.415A.5.5 0 0 0 13.086 1H13v4.5A1.5 1.5 0 0 1 11.5 7h-7A1.5 1.5 0 0 1 3 5.5V1H1.5a.5.5 0 0 0-.5.5m3 4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V1H4zM3 15h10v-4.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5z"/>
    </svg>
);
const IconArrowCounterclockwise = ({ size = 16, ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="currentColor" viewBox="0 0 16 16" {...props}>
        <path fillRule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z"/>
        <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466"/>
    </svg>
);
const IconBoxArrowRight = ({ size = 16, ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="currentColor" viewBox="0 0 16 16" {...props}>
        <path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"/>
        <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
    </svg>
);
const IconClipboardCheck = ({ size = 16, ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="currentColor" viewBox="0 0 16 16" {...props}>
        <path fillRule="evenodd" d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0"/>
        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z"/>
        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z"/>
    </svg>
);
const IconFileEarmarkText = ({ size = 16, ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="currentColor" viewBox="0 0 16 16" {...props}>
        <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5"/>
        <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>
    </svg>
);

/* ── 簡編專用 styled-components ── */
const PageDesc = styled.p`
    color: #64748b; font-size: 14px; margin: 0 0 12px 0; line-height: 1.6;
`;
const LegendRow = styled.div`
    display: flex; gap: 16px; align-items: center; flex-wrap: wrap; margin-bottom: 8px;
`;
const LegendBadge = styled.span`
    display: inline-flex; align-items: center; gap: 4px; font-size: 12px;
    &::before {
        content: ''; display: inline-block; width: 10px; height: 10px; border-radius: 2px;
        background: ${p => p.$color || '#ccc'};
    }
`;
const CatalogTypeBar = styled.div`
    display: inline-flex; border: 1px solid #e2e8f0; border-radius: 8px; overflow: hidden; margin-bottom: 4px;
`;
const CatalogTypeTab = styled.button`
    padding: 8px 24px; border: none; cursor: pointer; font-size: 14px; font-weight: 500;
    display: inline-flex; align-items: center; gap: 6px;
    transition: all .15s;
    background: ${p => p.$active ? '#fa8c16' : '#fff'};
    color: ${p => p.$active ? '#fff' : '#64748b'};
    &:hover { background: ${p => p.$active ? '#fa8c16' : '#f1f5f9'}; }
    &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

const CATALOG_TYPE_BOOK = "book";
const CATALOG_TYPE_SERIAL = "serial";

const GeneralBibliographicEditModeTable = ({
    rowKey = "biblionumber",
    keyPrefix = "cataloging.bibliographic_management",
    showAllColumns = true,
    propsShowColumns,
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }//selectInfo
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const navigate = useNavigate()
    const columns = [
        {
            title: t("bib_biblionumber"),
            key: "bib_biblionumber",
            dataIndex: "bib_biblionumber",
            align: "center",
            sorter: false
        },
        {
            title: t("bib_notes"),
            key: "bib_notes",
            dataIndex: "bib_notes",
            align: "center",
            sorter: false
        },
        {
            title: t("bib_copyrightdate"),
            key: "bib_copyrightdate",
            dataIndex: "bib_copyrightdate",
            align: "center",
            sorter: false
        },
        {
            title: t("bib_datecreated"),
            key: "bib_datecreated",
            dataIndex: "bib_datecreated",
            align: "center",
            sorter: false
        },
        {
            title: t("bib_seriestitle"),
            key: "bib_seriestitle",
            dataIndex: "bib_seriestitle",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_biblioitemnumber"),
            key: "bibitem_biblioitemnumber",
            dataIndex: "bibitem_biblioitemnumber",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_volume"),
            key: "bibitem_volume",
            dataIndex: "bibitem_volume",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_itemtype"),
            key: "bibitem_itemtype",
            dataIndex: "bibitem_itemtype",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_itemtype_description"),
            key: "bibitem_itemtype_description",
            dataIndex: "bibitem_itemtype_description",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_isbn"),
            key: "bibitem_isbn",
            dataIndex: "bibitem_isbn",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_publishercode"),
            key: "bibitem_publishercode",
            dataIndex: "bibitem_publishercode",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_editionstatement"),
            key: "bibitem_editionstatement",
            dataIndex: "bibitem_editionstatement",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_illus"),
            key: "bibitem_illus",
            dataIndex: "bibitem_illus",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_pages"),
            key: "bibitem_pages",
            dataIndex: "bibitem_pages",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_notes"),
            key: "bibitem_notes",
            dataIndex: "bibitem_notes",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_size"),
            key: "bibitem_size",
            dataIndex: "bibitem_size",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_place"),
            key: "bibitem_place",
            dataIndex: "bibitem_place",
            align: "center",
            sorter: false
        },
        // {
        //     title: t("bib_cover_images"),
        //     key: "bib_cover_images",
        //     dataIndex: "bib_cover_images",
        //     align: "center",
        //     sorter: false
        // },
        {
            title: t("items_count"),
            key: "items_count",
            dataIndex: "items_count",
            align: "center",
            sorter: false
        },
        {
            title: t("items_borrowed_count"),
            key: "items_borrowed_count",
            dataIndex: "items_borrowed_count",
            align: "center",
            sorter: false
        },
        // {
        //     title: t("metadata"),
        //     key: "metadata",
        //     dataIndex: "metadata",
        //     align: "center",
        //     sorter: false
        // },
        {
            title: t("rank"),
            key: "rank",
            dataIndex: "rank",
            align: "center",
            sorter: false
        },
        {
            title: t("bib_format"),
            key: "bib_format",
            dataIndex: "bib_format",
            align: "center",
            sorter: false
        },
        {
            title: t("bib_literaryform"),
            key: "bib_literaryform",
            dataIndex: "bib_literaryform",
            align: "center",
            sorter: false
        },
        {
            title: t("bib_title"),
            key: "bib_title",
            dataIndex: "bib_title",
            align: "center",
            sorter: false
        },
        // {
        //     title: t("bib_othertitle"),
        //     key: "bib_othertitle",
        //     dataIndex: "bib_othertitle",
        //     align: "center",
        //     sorter: false
        // },
        {
            title: t("bib_author"),
            key: "bib_author",
            dataIndex: "bib_author",
            align: "center",
            sorter: false,
            render: ((text) => {

            })
        },
        // {
        //     title: t("bib_translator"),
        //     key: "bib_translator",
        //     dataIndex: "bib_translator",
        //     align: "bib_translator",
        //     sorter: false
        // },
        // {
        //     title: t("bib_language"),
        //     key: "bib_language",
        //     dataIndex: "bib_language",
        //     align: "bib_language",
        //     sorter: false
        // },
        {
            title: t("bib_publisher"),
            key: "bib_publisher",
            dataIndex: "bib_publisher",
            align: "bib_publisher",
            sorter: false
        },
        {
            title: t("bib_view_times"),
            key: "bib_view_times",
            dataIndex: "bib_view_times",
            align: "bib_view_times",
            sorter: false
        },
        {
            title: t("bib_borrow_times"),
            key: "bib_borrow_times",
            dataIndex: "bib_borrow_times",
            align: "bib_borrow_times",
            sorter: false
        },
    ];
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : ['question_and_answer_data', 'title'])
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record?.[rowKey]);
                selectRow = selectRow.filter((row) => row?.[rowKey] !== record?.[rowKey]);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [form] = Form.useForm();


    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }

    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };


    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    const GeneralBibliographicEditModeController = useCRUDController({
        apiRoute: "/koha/bib",
        onFinish,
        onBefore
    })
    useEffect(() => {
        checkAll();

    }, []);
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    return (<Row>
        <Col span={24}>
            <ProTableOt
                formMode={true}
                actionRef={actionRef}
                headerTitle={
                    <></>
                }
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={rowKey}

                toolBarRender={() => {
                    return []
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    let newParams = {};
                    let order = setOrders(sort);
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        "datecreated_start": "2024-04-01",
                        "datecreated_end": "2025-04-30",
                        // custom_filter_value: params.keyword ?? "",
                        // custom_filter_key: custom_filter_key,
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return GeneralBibliographicEditModeController.getData(newParams);
                    // return []
                }}
                pageSize={pageSize}
                rowSelection={
                    {
                        type: rowSelectType,
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }
                }

                propsPatchProcess={(data) => {
                    return {
                        ...data,
                        axiosMode: "patch"
                    }
                }}
                initialValues={{
                    "axiosMode": "post",
                }}
                propsPostOnBefore={(data) => {
                    return {
                        ...data,
                        axiosMode: "post"
                    }
                }}
                propsUseData={() => {
                    return {
                        postData: (formData) => {

                            let postData = formData.map((formValue) => {
                                return {
                                    ...formValue,
                                }

                            })
                            GeneralBibliographicEditModeController.postData(postData)
                        },
                        patchData: (formData) => {
                            let patchData = formData.map((formValue) => {
                                return {
                                    ...formValue,
                                }
                            })
                            GeneralBibliographicEditModeController.patchData(patchData)
                        },
                        deleteData: (data) => {
                            let newData = data.filter(ele => ele?.frameworkcode !== "")
                            GeneralBibliographicEditModeController.deleteData(newData)
                        }
                    }
                }}
                PropsPatchForm={<GeneralBibliographicEditModeForm />}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                propsPatch
                propsDelete
                propsPost
                propsWidth={1200}
                scroll={{
                    x: "100%",
                }}
                extraActionRender={(record) => {
                    return (<Col>

                    </Col>)
                }}
            />
        </Col>
    </Row>)

}
const GeneralBibliographicEditMode = ({
    keyPrefix = "cataloging.bibliographic_management",
    propsOnCancel = () => { }
}) => {

    const navigate = useNavigate()
    const { t } = useTranslation('translation', { keyPrefix })
    const [searchParams, setSearchParams] = useSearchParams();
    const biblionumber = searchParams.get('bib_biblionumber');
    const mode = searchParams.get('mode');
    const [form] = Form.useForm();
    const [reloadCount, setReloadCount] = useState(0)
    const [modalLoading, setModalLoading] = useState(false);
    const [catalogType, setCatalogType] = useState(CATALOG_TYPE_BOOK);

    // ── 共用欄位（圖書 & 期刊都會出現） ──
    const sharedFields = [
        {
            "tagfield": "245", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "a", "row": 0,
            "libopac": "書名(Title)", "content": "",
            "_section": "required"
        },
        {
            "tagfield": "245", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "b", "row": 0,
            "libopac": "副題名(Remainder of title)", "content": "",
            "_section": "optional"
        },
        {
            "tagfield": "246", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "a", "row": 0,
            "libopac": "並列題名(Title proper/short title)", "content": "",
            "_section": "optional"
        },
        {
            "tagfield": "250", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "a", "row": 0,
            "libopac": "版本(Edition statement)", "content": "",
            "_section": "optional"
        },
        {
            "tagfield": "260", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "a", "row": 0,
            "libopac": "出版地(Place of publication, distribution, etc.)", "content": "",
            "_section": "optional"
        },
        {
            "tagfield": "260", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "b", "row": 0,
            "libopac": "出版者(Name of publisher, distributor, etc.)", "content": "",
            "_section": "required"
        },
        {
            "tagfield": "260", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "c", "row": 0,
            "libopac": "出版年(Date of publication, distribution, etc.)", "content": "",
            "_section": "required"
        },
        {
            "tagfield": "300", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "a", "row": 0,
            "libopac": "頁面數(Extent)", "content": "",
            "_section": "required"
        },
        {
            "tagfield": "300", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "b", "row": 0,
            "libopac": "插圖(Other physical details)", "content": "",
            "_section": "optional"
        },
        {
            "tagfield": "300", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "c", "row": 0,
            "libopac": "高廣尺寸(Dimensions)", "content": "",
            "_section": "optional"
        },
        {
            "tagfield": "300", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "e", "row": 0,
            "libopac": "附件(Accompanying material)", "content": "",
            "_section": "optional"
        },
        {
            "tagfield": "490", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "a", "row": 0,
            "libopac": "集叢名(Series statement)", "content": "",
            "_section": "optional"
        },
        {
            "tagfield": "490", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "v", "row": 0,
            "libopac": "集叢號(Volume/sequential designation)", "content": "",
            "_section": "optional"
        },
        {
            "tagfield": "500", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "a", "row": 0,
            "libopac": "附註項(General note)", "content": "",
            "_section": "optional"
        },
        {
            "tagfield": "520", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "a", "row": 0,
            "libopac": "摘要註(Summary, etc.)", "content": "",
            "_section": "optional"
        },
        {
            "tagfield": "020", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "c", "row": 0,
            "libopac": "價格(Terms of availability)", "content": "",
            "_section": "optional"
        },
        {
            "tagfield": "020", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "q", "row": 0,
            "libopac": "裝訂(Qualifying information)", "content": "",
            "_section": "optional"
        },
        {
            "tagfield": "110", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "a", "row": 0,
            "libopac": "主要單位(Corporate name or jurisdiction name as entry element)", "content": "",
            "_section": "optional"
        },
        {
            "tagfield": "110", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "b", "row": 0,
            "libopac": "副屬單位(Subordinate unit)", "content": "",
            "_section": "optional"
        },
        {
            "tagfield": "110", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "e", "row": 0,
            "libopac": "著作方式(Relator term)", "content": "",
            "_section": "optional"
        },
        {
            "tagfield": "100", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "e", "row": 0,
            "libopac": "著作方式(Relator term)", "content": "",
            "_section": "optional"
        },
        {
            "tagfield": "100", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "e", "row": 1,
            "libopac": "著作方式(Relator term)", "content": "",
            "_section": "optional"
        },
    ];

    // ── 圖書專用欄位（3 個） ──
    const bookOnlyFields = [
        {
            "tagfield": "020", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "a", "row": 0,
            "libopac": "ISBN(International Standard Book Number)", "content": "",
            "_section": "required"
        },
        {
            "tagfield": "100", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "a", "row": 0,
            "libopac": "主要作者(Personal name)", "content": "",
            "_section": "required"
        },
        {
            "tagfield": "100", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "a", "row": 1,
            "libopac": "個人作者(Personal name)", "content": "",
            "_section": "optional"
        },
    ];

    // ── 期刊專用欄位（5 個可見 + 1 個隱藏） ──
    const serialOnlyFields = [
        {
            "tagfield": "022", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "a", "row": 0,
            "libopac": "ISSN", "content": "",
            "_section": "required"
        },
        {
            "tagfield": "310", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "a", "row": 0,
            "libopac": "目前刊期", "content": "",
            "_section": "required"
        },
        {
            "tagfield": "362", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "a", "row": 0,
            "libopac": "出版卷期", "content": "",
            "_section": "required"
        },
        {
            "tagfield": "780", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "t", "row": 0,
            "libopac": "期刊更名前", "content": "",
            "_section": "optional"
        },
        {
            "tagfield": "785", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "t", "row": 0,
            "libopac": "期刊更名後", "content": "",
            "_section": "optional"
        },
        // 期刊隱藏 100a，但送出時需帶「無」
        {
            "tagfield": "100", "ind1_defaultvalue": "", "ind2_defaultvalue": "",
            "tagsubfield": "a", "row": 0,
            "libopac": "個人作者(Personal name)", "content": "無",
            "_hidden": true, "_section": "required"
        },
    ];

    /** 根據 catalogType 組合 bookdata */
    const getDefaultBookdata = useCallback((type) => {
        const typeFields = type === CATALOG_TYPE_SERIAL ? serialOnlyFields : bookOnlyFields;
        return [...typeFields, ...sharedFields];
    }, []);

    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                console.log('[簡編模式] POST 回傳:', values)
                // 後端回傳結構: { status, data: [{ result: { data: { id: 75963 } } }] }
                let data = values?.data || []
                let firstData = Array.isArray(data) ? data[0] : data
                let newBiblionumber = firstData?.result?.data?.id
                    || firstData?.biblionumber
                    || firstData?.bib_biblionumber
                if (newBiblionumber) {
                    navigate(`/library/backstage/EditMARC?bib_biblionumber=${newBiblionumber}&defaultEditMode=book`)
                }
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                if (biblionumber) {
                    dataReload(biblionumber)
                }
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        if (axiosMode !== "get") {
            setModalLoading(true);
        }
    };
    /**
     * 將簡編模式的 bookdata 扁平陣列轉換為後端 POST/PATCH /koha/bib 需要的格式
     */
    const convertBookdataToPayload = (formValues) => {
        const bookdata = formValues?.bookdata || [];
        const isSerial = catalogType === CATALOG_TYPE_SERIAL;

        // 1. 決定 leader（圖書 m / 期刊 s）
        const leader = isSerial
            ? '     nas a22     ui 4500'
            : '     nam a22     ui 4500';

        // 2. 產生 008 controlfield
        const today = new Date();
        const yy = String(today.getFullYear()).slice(2);
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const year = String(today.getFullYear());
        const text008 = `${yy}${mm}${dd}s${year}    ch            000 0 chi d`;

        // 3. 將 bookdata 按 tagfield+row 群組化成 datafield
        //    同一 tagfield+row 的多筆 subfield 合併
        const groupMap = {};
        let bibTitle = '';

        bookdata.forEach(item => {
            // 跳過沒有 tagfield 的項目
            if (!item?.tagfield) return;
            // 跳過空值項目（但保留 _hidden 帶預設值的項目）
            if (!item?.value && item?.value !== 0 && !item?.content) return;

            const tag = item.tagfield;
            const row = item.row ?? 0;
            const groupKey = `${tag}_${row}`;
            const actualValue = item.value || item.content || '';

            if (!groupMap[groupKey]) {
                groupMap[groupKey] = {
                    tag: tag,
                    ind1: item.ind1_defaultvalue || ' ',
                    ind2: item.ind2_defaultvalue || ' ',
                    subfield: []
                };
            }
            groupMap[groupKey].subfield.push({
                code: item.tagsubfield,
                text: String(actualValue)   // 後端要求 key 為 "text"，不是 "value"
            });

            // 取得書名用於 bib_title
            if (tag === '245' && item.tagsubfield === 'a') {
                bibTitle = String(actualValue);
            }
        });

        const datafield = Object.values(groupMap);

        // 4. 組裝最終結構
        const payload = {
            bib_title: bibTitle,
            metadata: {
                leader: leader,
                controlfield: [
                    { tag: '008', text: text008 }
                ],
                datafield: datafield
            }
        };

        return payload;
    };

    const onFormFinish = (value) => {
        const payload = convertBookdataToPayload(value);
        console.log('[簡編模式] 送出 payload:', JSON.stringify(payload, null, 2));
        // 使用 URL searchParams 的 biblionumber 判斷是新增還是修改
        // 不使用 form value，因為它可能是字串 "undefined"
        if (biblionumber) {
            payload.biblionumber = biblionumber;
            BibBookController.patchData([payload])
        } else {
            BibBookController.postData([payload])
        }
    }
    /**
     * 將 GET /koha/bib?marcdata=json 回傳的巢狀 MARC 結構
     * 展平成 bookdata 扁平陣列（tagfield / tagsubfield / content / ind1 / ind2 / row）
     */
    const flattenMarcToBookdata = (marcRecord) => {
        const flat = [];
        const metadata = marcRecord?.metadata;
        if (!metadata) return flat;

        const datafield = metadata.datafield || [];
        // 追蹤同一 tag 出現的次數，用來決定 row
        const tagCounter = {};

        datafield.forEach(df => {
            const tag = df.tag;
            const ind1 = df.ind1 ?? '';
            const ind2 = df.ind2 ?? '';
            const subfields = df.subfield || [];

            // 計算此 tag 是第幾次出現
            if (!tagCounter[tag]) tagCounter[tag] = 0;
            const row = tagCounter[tag];
            tagCounter[tag]++;

            subfields.forEach(sf => {
                flat.push({
                    tagfield: tag,
                    tagsubfield: sf.code,
                    ind1_defaultvalue: ind1,
                    ind2_defaultvalue: ind2,
                    row: row,
                    content: sf.text ?? '',
                });
            });
        });

        return flat;
    };

    /**
     * 從 leader 判斷是圖書 (nam) 還是期刊 (nas)
     */
    const detectCatalogTypeFromLeader = (leader) => {
        if (typeof leader === 'string' && leader.includes('nas')) {
            return CATALOG_TYPE_SERIAL;
        }
        return CATALOG_TYPE_BOOK;
    };

    const dataReload = (reloadBiblionumber) => {
        if (reloadBiblionumber) {
            BibBookController.getData({
                biblionumber: reloadBiblionumber,
                "marcdata": "json"
            }).then((response) => {
                // GET 回傳結構: { data: [{ metadata: { leader, controlfield, datafield }, key }], total }
                const records = response?.data || [];
                const firstRecord = Array.isArray(records) ? records[0] : records;

                // 從 leader 自動判斷圖書/期刊並切換
                const detectedType = detectCatalogTypeFromLeader(firstRecord?.metadata?.leader);
                if (detectedType !== catalogType) {
                    setCatalogType(detectedType);
                }

                // 將巢狀 MARC 結構展平成 bookdata 扁平陣列
                const flatBookdata = flattenMarcToBookdata(firstRecord);

                // 以預設欄位定義為基底，合併 API 回傳的值
                // 確保 _section / _hidden / libopac 等前端欄位完整
                const defaultBookdata = getDefaultBookdata(detectedType);
                const mergedBookdata = defaultBookdata.map(def => {
                    const match = flatBookdata.find(item =>
                        String(item.tagfield) === String(def.tagfield) &&
                        String(item.tagsubfield) === String(def.tagsubfield) &&
                        (item.row ?? 0) === (def.row ?? 0)
                    );
                    if (match) {
                        return {
                            ...def,
                            content: match.content ?? def.content,
                        };
                    }
                    return { ...def };
                });

                form.setFieldsValue({
                    "marcdata": detectedType,
                    biblionumber: reloadBiblionumber,
                    bookdata: mergedBookdata
                })
                setReloadCount((pre) => pre + 1)
            })
        } else {
            form.setFieldsValue({
                "marcdata": catalogType,
                bookdata: getDefaultBookdata(catalogType)
            })
        }
    }
    const BibBookController = useCRUDController({
        apiRoute: "/koha/bib",
        onFinish,
        onBefore
    })

    useEffect(() => {
        dataReload(biblionumber)
    }, [biblionumber])

    // catalogType 切換時重新載入預設欄位（只在新增模式下）
    useEffect(() => {
        if (!biblionumber) {
            form.setFieldsValue({
                "marcdata": catalogType,
                bookdata: getDefaultBookdata(catalogType)
            })
            setReloadCount((pre) => pre + 1)
        }
    }, [catalogType])

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5em', maxWidth: 1100, margin: '0 auto' }}>
            {/* ── 圖書 / 期刊 切換 + 按鈕列 ── */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
                <CatalogTypeBar>
                    <CatalogTypeTab
                        $active={catalogType === CATALOG_TYPE_BOOK}
                        disabled={!!biblionumber}
                        onClick={() => setCatalogType(CATALOG_TYPE_BOOK)}
                    >
                        <IconBook size={15} /> 圖書（Book）
                    </CatalogTypeTab>
                    <CatalogTypeTab
                        $active={catalogType === CATALOG_TYPE_SERIAL}
                        disabled={!!biblionumber}
                        onClick={() => setCatalogType(CATALOG_TYPE_SERIAL)}
                    >
                        <IconJournalText size={15} /> 期刊（Serial）
                    </CatalogTypeTab>
                </CatalogTypeBar>
                <Row gutter={[8, 8]}>
                    <Col>
                        <Button
                            variant="outline"
                            onClick={() => {
                                if (!biblionumber) {
                                    form.setFieldsValue({
                                        "marcdata": catalogType,
                                        bookdata: getDefaultBookdata(catalogType)
                                    })
                                    setReloadCount((pre) => pre + 1)
                                }
                            }}>
                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                <IconArrowCounterclockwise size={14} /> 重置
                            </span>
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            loading={modalLoading}
                            onClick={() => { form.submit() }}>
                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                <IconFloppy size={14} /> 儲存書目
                            </span>
                        </Button>
                    </Col>
                </Row>
            </div>

            {/* ── 單一 Form 包裹所有 Card ── */}
            <Form
                form={form}
                onFinish={onFormFinish}
                autoComplete="off"
            >
                {/* 隱藏的 biblionumber 與 marcdata */}
                <Form.Item name="biblionumber" hidden><Input /></Form.Item>
                <Form.Item name="marcdata" hidden><Input /></Form.Item>

                {/* 單一 FormItemComponent，內部分組為 required / optional Cards */}
                <GeneralBibliographicEditModeForm
                    propsForm={form}
                    onFormFinish={onFormFinish}
                    catalogType={catalogType}
                    section="cards"
                />
            </Form>

            {/* ── 底部操作按鈕列 ── */}
            <div style={{ display: 'flex', gap: '0.75em', justifyContent: 'flex-end' }}>
                <Button
                    variant="outline"
                    onClick={() => { propsOnCancel() }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                        <IconBoxArrowRight size={14} /> 離開簡編模式
                    </span>
                </Button>
                <Button
                    loading={modalLoading}
                    onClick={() => { form.submit() }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                        <IconFloppy size={14} /> 儲存書目
                    </span>
                </Button>
            </div>

            {/* ── 底部提示 ── */}
            <p style={{ color: '#94a3b8', fontSize: 12, textAlign: 'center', margin: '0.5em 0 0' }}>
                此頁面僅建立書目資料（Bibliographic Record），不包含館藏資料（Holdings）。
                輸出格式符合 MARC21 規範，可直接寫入圖書館系統。
            </p>
        </div>
    );
};
export { GeneralBibliographicEditModeTable }
export default GeneralBibliographicEditMode;
